import React from 'react';
import { topBarClick } from '@wix/bi-logger-editor/v2';
import {
  MigrationBannerType,
  SectionsMigrationBanner,
} from './sectionsMigrationBanner';
import constants from '#packages/constants';
import { sections, biLogger } from '#packages/util';
import { resolveMigrationFlow } from '#packages/sectionsMigration/api';
import {
  SECTIONS_MIGRATION_BANNER,
  PER_PAGE_MIGRATION,
} from '../../utils/translations';
import { perPageMigrationBanner } from '../../utils';

import type { SectionsMigrationScope as Scope } from '../../scope';

export const initSectionsMigrationBanner = (scope: Scope) => {
  const flow = resolveMigrationFlow(scope);

  scope.workspaceAPI.contributeTopBannerComponent(
    () => (
      <SectionsMigrationBanner
        type={MigrationBannerType.SITE}
        text={SECTIONS_MIGRATION_BANNER.TOP_BAR_BANNER_TEXT}
        link={SECTIONS_MIGRATION_BANNER.TOP_BAR_BANNER_CTA}
        onLinkClick={() =>
          scope.editorAPI.panelManager.openPanel(
            constants.PANELS.PROMOTIONAL.OPTIONAL_SECTIONS_MIGRATION_PANEL,
            {
              origin: 'top_bar_notification',
            },
          )
        }
      />
    ),
    () => sections.isSectionsMigrationBannerEnabled(),
  );

  scope.workspaceAPI.contributeStageBannerComponent(
    () => (
      <SectionsMigrationBanner
        type={MigrationBannerType.PAGE}
        text={PER_PAGE_MIGRATION.ERROR_TOP_BAR_BANNER_TEXT}
        link={PER_PAGE_MIGRATION.ERROR_TOP_BAR_BANNER_CTA}
        onLinkClick={() => {
          biLogger.report(
            topBarClick({ category: 'contact_support', origin: flow }),
          );

          window.open(
            'https://www.wix.com/support-chatbot?nodeId=3f82b48c-1005-43cb-b3ff-8ae85fa980a6&referral=PageMigration',
            '_blank',
          );
        }}
      />
    ),
    () => perPageMigrationBanner.isVisible(),
  );
};
